module.exports = __webpack_public_path__ + "media/images/slash-6b83a49f.svg";